<template>
    <div class="ShareBtn my-4">
      <div>
        <p>اشتراک گذاری در</p>
      </div>
      <div class="w-100px d-flex justify-content-between">
        <a aria-label="Twitter" :href="'https://twitter.com/intent/tweet?text=' + host + $route.fullPath"><i class="fab fa-twitter color-twitter"></i></a>
        <a aria-label="Whatsapp" :href="'whatsapp://send?text=' + host + $route.fullPath"><i class="fab fa-whatsapp color-whatsapp"></i></a>
        <a aria-label="Telegram" :href="'https://telegram.me/share/url?url=' + host + $route.fullPath"><i class="fab fa-telegram color-telegram"></i></a>
      </div>
    </div>
</template>

<script>
export default {
  name: 'ShareBtn',
  data () {
    return {
      host: window.location.protocol + '//' + window.location.host
    }
  }
}
</script>

<style scoped>
.w-100px{
  width: 100px;
}
p{
  font-size: 12pt;
  color: gray;
}
.ShareBtn{
  display: flex;
  justify-content: space-evenly;
  font-size: 19px;
}
</style>
